module.exports = __webpack_public_path__ + "assets/img/xx-title.8e1af2c6.png";